import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fromStore } from '../../../selectors';
import Loader from '../../../components/utils/Loader';
import InfoBox from '../../../components/utils/InfoBox';
import { isEmpty } from 'lodash';
import { formatDateTime } from '../../../utils/formatDateTime';
import { fetchGoods, fetchRawsList, getRecipeById, setActiveModalAction } from '../../../action';
import swal from "sweetalert";
import { MEASURES_RAW } from '../../rawmaterials/constansts';
import { deleteReceipe } from '../../../action/recipes';

const styles = {
    loading: {
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'center'
    }
}

export function RecipeGood() {
    const dispatch = useDispatch();
    const detail = useSelector(fromStore.detailGoodSelector);
    const loaderReceipe = useSelector(fromStore.loaderRecipeGoodSelector);
    const raws = useSelector(fromStore.rawListSelector);
    const goods = useSelector(fromStore.goodListSelector);
    const loaderList = useSelector(fromStore.loaderRawsSelector);
    const loaderListGood = useSelector(fromStore.loaderGoodsSelector);
    const loading = loaderReceipe || loaderList || loaderListGood;
    const [activeReceipe, setActiveReceipe] = useState(null);
    const id = detail ? detail.id : null;

    const recipeLoaded = detail && detail.recipes;

    useEffect(() => {
        if (id && !recipeLoaded) dispatch(getRecipeById(id));
        if (recipeLoaded && recipeLoaded.length > 0) setActiveReceipe(detail.recipes[0]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, id, recipeLoaded]);

    useEffect(() => {
        if (isEmpty(raws)) dispatch(fetchRawsList());
        if (isEmpty(goods)) dispatch(fetchGoods());
    }, [dispatch, raws, goods]);

    const onOpenCopyRecipe = (e) => {
        e.stopPropagation();
        let receipeData = {
            ...activeReceipe,
            id: null,
            startDate: new Date()
        }
        if (detail && detail.id && (!receipeData || !receipeData.data) && recipeLoaded && recipeLoaded.length > 2) swal({
            title: 'Копирование рецепта невозможно',
            text: 'Ограничение кол-ва рецептов - 3. Чтобы создать новый рецепт - удалите старый.',
            icon: "error",
            dangerMode: true,
            button: "Ок",
        }) 
        dispatch(setActiveModalAction({ field: 'recipes', value: { data: receipeData, type: 'good', action: 'copy' }}));
    }

    const onOpenEditRecipe = (e) => {
        e.stopPropagation();
        dispatch(setActiveModalAction({ field: 'recipes', value: { data: activeReceipe, type: 'good' }}));
    };

    const handleDelete = () => {
        swal({
            title: "Удаление рецепта",
            text: `Вы действительно хотите удалить рецепт за ${new Date(activeReceipe.startDate).toLocaleDateString()}?`,
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then(async (willDelete) => {
            if (willDelete) {
                const result = await dispatch(deleteReceipe(activeReceipe.id, 'good'));
                if (result) setActiveReceipe(result[0]);
            }
        });
    };

    const renderTable = (recipes, title, quantityField, buttons) => (
        <div className="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded">
            <table className="kt-datatable__table" style={{ width: '100%' }}>
                <thead className="kt-datatable__head">
                <tr className="kt-datatable__row">
                    <th colSpan="3" className="kt-datatable__cell kt-datatable__title">
                        {title}
                    </th>
                    {buttons && <th>
                        {renderButtons()}
                    </th>}
                </tr>
                <tr className="kt-datatable__row">
                    <th width="145px" className="kt-datatable__cell kt-datatable__cell--sort">
                        <span>Наименование</span>
                    </th>
                    <th width="auto" className="kt-datatable__cell kt-datatable__cell--sort">
                        <span style={{ textAlign: 'left' }}></span>
                    </th>
                    <th width="145px" className="kt-datatable__cell kt-datatable__cell--sort">
                        <span style={{ textAlign: 'center' }}>Количество</span>
                    </th>
                </tr>
                </thead>
                <tbody className="kt-datatable__body">
                {recipes.map((item) => (
                    <tr key={item.id} className="kt-datatable__row">
                        <td width="145px" className="kt-datatable__cell">{item.name || 'DELETED'}</td>
                        <td align="left" width="auto" className="kt-datatable__cell">{MEASURES_RAW[item.measure] || ''}</td>
                        <td align="center" width="145px" className="kt-datatable__cell">{item.quantity[quantityField] || 0}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );

    const renderDateTabs = () => (
        <div className="inner-date-tabs" style={{ marginBottom: '1rem' }}>
            <ul className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-tabs-bold nav-tabs-line-3x nav-tabs-line-brand">
                {detail.recipes.map((recipe) => (
                    <li key={recipe.id} className="nav-item">
                        <button
                            onClick={() => setActiveReceipe(recipe)}
                            className={`nav-link ${(activeReceipe && recipe.id === activeReceipe.id) ? 'active' : ''}`}
                        >
                            {formatDateTime(recipe.startDate)}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );

    const renderButtons = () => {
        return (
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                <button
                    onClick={onOpenCopyRecipe}
                    title={'Копировать'}
                    disabled={loading}
                    className={"btn btn-sm btn-icon btn-icon-md btn-primary"}>
                    <i className="flaticon2-copy"></i>
                </button>
                <button
                    onClick={onOpenEditRecipe}
                    title={'Редактировать'}
                    disabled={loading}
                    className={"btn btn-sm btn-icon btn-icon-md btn-primary"}>
                    <i className="flaticon2-contract"></i>
                </button>
                <button
                    onClick={handleDelete}
                    title={'Удалить'}
                    disabled={loading}
                    className={"btn btn-sm btn-icon btn-icon-md btn-danger"}>
                    <i className="la la-trash"></i>
                </button>
            </div>
        );
    };

    const renderName = (item, type) => {
        let categoryText;

        if (type === 'good') {
            categoryText = (item.category && item.category.title) ? item.category.title : null;
        } else {
            categoryText = (item.productscategory && item.productscategory.title) ? item.productscategory.title : null;
        }

        return categoryText ? `${categoryText}: ${item.name || `Наименование товара id ${item.id} не определено`}` : item.name || `Наименование товара id ${item.id} не определено`;
    }

    const getIngredients = (ingredients) => {
        if (!ingredients) return [];

        const getIngredientName = (good, modId, type) => {
            if (isEmpty(good.modifications)) return renderName(good, type);

            let mod = null;
            if (modId) {
                mod = good.modifications.find((item) => item.id === modId);
            } else {
                mod = good.modifications.find((item) => item.default);
            }
            
            if (!mod) return renderName(good, type);
            return `${renderName(good, type)} ${mod.title || `Наименование модификации id ${modId} не определено`}`
        }

        const result = ingredients.map((ingredient) => {
            let entity = null;
            const partsId = typeof ingredient.id === 'string' ? ingredient.id.split('_') : null;
            const ingredientId = (partsId && partsId[0]) ? parseInt(partsId[0]) : ingredient.id;
            const modId = (partsId && partsId[1]) ? parseInt(partsId[1]) : null;

            if (ingredient.type === 'good') {
                entity = goods.find((good) => good.id === ingredientId);
                entity.measure = 'pc';
            } else {
                entity = raws.find((raw) => raw.id === ingredientId);
            }

            const name = getIngredientName(entity, modId, ingredient.type)
            return { ...ingredient, name, measure: entity.measure };
        });
        return result;
    }
    
    const renderContentForActiveDate = () => {
        if (!activeReceipe) return;
        const ingredients = getIngredients(activeReceipe.ingredients);

        const groups = ingredients ? ingredients.reduce((acc, i) => {
            acc[i.type] = [...(acc[i.type] || []), i];
            return acc;
        }, {}) || {} : {};
        
        const { raw: raws = [], semi: semis = [], good: goods = [] } = groups;
        
        return (
            <div>
                {renderDateTabs()}
                {raws.length <= 0 && semis.length <= 0 && goods.length <= 0 && <button
                    onClick={handleDelete}
                    title={'Удалить'}
                    disabled={loading}
                    className={"btn btn-sm btn-icon btn-icon-md btn-danger"}>
                    <i className="la la-trash"></i>
                </button>}
                {detail && !isEmpty(detail.modifications) && <h4 style={{ color: "black", paddingLeft: '25px' }}>По умолчанию</h4>}
                {raws.length > 0 && renderTable(raws, 'Сырье', 'default', true)}
                {semis.length > 0 && renderTable(semis, 'Полуфабрикаты', 'default', raws.length <= 0)}
                {goods.length > 0 && renderTable(goods, 'Товары', 'default', raws.length <= 0 && semis.length <= 0)}
                {renderModifications(detail.modifications, groups)}
            </div>
        );
    };

    const renderModifications = (modifications, groups) => {
        if (!activeReceipe) return;
        const { ingredients } = activeReceipe;

        if (!modifications || modifications.length === 0) return;
        const mods = modifications.filter((mod) => !mod.default);
        if (!mods || mods.length === 0) return;
        
        const { raw: raws = [], semi: semis = [], good: goods = [] } = groups;

        return mods.map((mod) => {
            const isRender = ingredients.some((ingredient) => Object.keys(ingredient.quantity || {}).some(key => key === String(mod.id)));
            if (!isRender) return null;
            return(
                <div key={mod.id}>
                    <div className="kt-separator kt-separator--border-dashed kt-separator--space-sm"></div>
                    {<h4 style={{ color: "black", paddingLeft: '25px' }}>Модификация {mod.title}</h4>}
                    {raws.length > 0 && renderTable(raws, 'Сырье', mod.id, true)}
                    {semis.length > 0 && renderTable(semis, 'Полуфабрикаты', mod.id, raws.length <= 0)}
                    {goods.length > 0 && renderTable(goods, 'Товары', mod.id, raws.length <= 0 && semis.length <= 0)}
                </div>
            )
        });
    }

    return (
        <>
            {loading ? (
                <div style={styles.loading}><Loader /></div>
            ) : (
                <>
                    <div className="kt-portlet__body" style={{ minHeight: '350px', padding: '1rem' }}>
                        {!isEmpty(detail.recipes) ? (
                            renderContentForActiveDate()
                        ) : (
                            <div style={{ padding: '20px' }}>
                                <InfoBox
                                    title="Ингредиенты"
                                    subtitle="Для товара нет ингредиентов"
                                />
                            </div>
                        )}
                    </div>
                </>
            )}
        </>
    );
}
